<template>
    <div id="page-branch-list">
        <div class="vx-card px-6 py-4">
            <!-- <div class="vx-col md:w-full flex items-center mb-5">
                <TitleScreen></TitleScreen>
            </div> -->
            <div class="vx-row">
                <div class="vx-col md:w-1/3 w-full">
                    <label class="vs-input--label">{{ $t('menuHistory.branch') }}</label>
                    <v-select class="" v-model="selectedOrganizationBranch"
                              :options="organizationBranchOptions">
                        <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                    </v-select>
                </div>
                <div class="vx-col md:w-1/3 w-full md:mt-0 mt-2">
                    <label class="vs-input--label">{{ $t('menuHistory.department') }}</label>
                    <v-select class="" v-model="selectedDepartment" :clearable="false" :options="departmentOptions">
                        <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                    </v-select>
                </div>
                <div class="vx-col md:w-1/3 w-full md:mt-0 mt-2">
                    <label class="vs-input--label">{{ $t('menuHistory.employee') }}</label>
                    <v-select class="" v-model="selectedEmployee" :clearable="false" :options="employeeOptions">
                        <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                    </v-select>
                </div>
                <div class="vx-col md:w-1/3 w-full mt-2">
                    <label class="vs-input--label">{{ $t('menuHistory.time') }}</label>
                    <!-- <div class="flex-grow"> -->
                    <date-range-picker
                        ref="picker" class="w-full"
                        :locale-data="{format: 'dd/mm/yyyy' }"
                        :opens="'left'"
                        @update="dateRangePicker"
                        v-model="dateRange" :timePicker="true" :autoApply="true">
                    </date-range-picker>
                    <!-- </div> -->
                </div>
                <div class="vx-col md:w-1/3 w-full mt-2">
                    <div class="flex-grow">
                        <label class="vs-input--label">{{ $t('menuEvent.selectDevice') }}</label>
                        <v-select class="" v-model="selectedDevice" :clearable="false"
                                  :options="deviceOptions">
                            <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                        </v-select>
                    </div>
                </div>
                <div class="vx-col md:w-1/3 w-full mt-2">
                    <div class="flex-grow" v-if="deviceId === 'camera'">
                        <label class="vs-input--label">{{ $t('menuHistory.selectCamera') }}</label>
                        <v-select class="" v-model="selectedCamera" :clearable="false"
                                  :options="cameraOptions">
                            <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                        </v-select>
                    </div>
                    <div class="flex-grow" v-if="deviceId === 'pad'">
                        <label class="vs-input--label">{{ $t('menuEvent.selectPad') }}</label>
                        <v-select class="" v-model="selectedPad" :clearable="false"
                                  :options="padsData">
                            <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                        </v-select>
                    </div>
                </div>

                <div class="vx-col md:w-1/3 w-full mt-6">
                    <vs-button class="" icon-pack="feather" icon="icon-search" @click="search">
                        {{ $t('menuHistory.filter') }}
                    </vs-button>
                    <!-- <vs-button class="mr-5 float-right" @click="exportFile" :disabled="!validateForm" v-if="isPermissionExport()">
                        {{ $t('menuHistory.createReport') }}
                    </vs-button> -->
                </div>
            </div>

            <!--            <div class="flex flex-wrap items-center mt-4">-->
            <!--                <div class="flex-grow"></div>-->
            <!--                <vs-input class="" v-model="searchQuery" @input="updateSearchQuery" :placeholder="$t('button.search')"/>-->
            <!--            </div>-->
            <!-- AgGrid Table -->
            <div class="custom-table-inout">
                <ag-grid-vue style=""
                             ref="agGridTable"
                             :components="components"
                             :gridOptions="gridOptions"
                             class="ag-theme-material w-100 my-4 ag-grid-table"
                             :columnDefs="columnDefs"
                             :defaultColDef="defaultColDef"
                             :rowData="workShiftData"
                             :animateRows="true"
                             :onGridReady="onGridReady"
                             :localeText=" {noRowsToShow: this.$t('menuCustomer.noRowsToShow')}"
                             :autoSizeStrategy="autoSizeStrategy"
                             tooltipShowDelay="0"
                             tooltipHideDelay="5000">
                </ag-grid-vue>
            </div>

            <div class="mt-4 flex flex-wrap" v-if="workShiftData.length > 0">
                <div class="">
                    <div class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 flex flex-wrap">
                        <span class="my-auto mr-2">Số phần tử / trang:</span>
                        <vs-dropdown vs-trigger-click class="cursor-pointer">
                            <div
                                class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium vx-col">
                                <span class="mr-2">
                                    {{
                                        workShiftData.length - currentPage * pageSize > 0 ? currentPage *
                                            pageSize
                                            : workShiftData.length
                                    }} / {{ totalElements }}
                                </span>
                                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
                            </div>
                            <vs-dropdown-menu>

                                <vs-dropdown-item @click="setPageSize(20)">
                                    <span>20</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="setPageSize(40)">
                                    <span>40</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="setPageSize(60)">
                                    <span>60</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="setPageSize(80)">
                                    <span>80</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="setPageSize(100)">
                                    <span>100</span>
                                </vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>
                    </div>
                </div>
                <div class="ml-auto">
                    <vs-pagination class="" :total="totalPages" v-model="currentPage" @change="changePage"/>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.vue-daterange-picker .ranges {
    float: right;
    border-left: 1px solid #ddd;
}

.daterangepicker {
    border-left: none !important;
}

.title-page {
    font-size: 2.2rem;
    font-weight: bold;
    display: flex;
}

.text-font {
    opacity: 0.7;
}

.reportrange-text {
    border-radius: 5px;
    height: 38px;
    line-height: 27px;
}

.mt-26 {
    margin-top: 26px;
}

.grid-cell-centered {
    text-align: center;
    justify-content: center;
}
</style>

<style lang="scss">
.custom-table-inout .ag-theme-material .ag-ltr .ag-cell {
    line-height: 70px;
}
</style>

<script>
import vSelect from 'vue-select'
import {AgGridVue} from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import authConfig from '@/../auth_config.json';
import Datepicker from 'vuejs-datepicker';
import moment from 'moment'; // Vuesax
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";
import Pagination from "../../ui-elements/Pagination.vue"
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import CellRendererImg from "../confirmTimeKeeping/cell-renderer/CellRendererImg"
import CellRendererDataAI from "./cell-renderer/CellRendererDataAI"
import DateRangePicker from '../../../components/vue2-daterange-picker/components/DateRangePicker.vue'
// import TitleScreen from "../../../layouts/main/TitleScreen";
import {isAPI} from '../../../store/permission';
import {constAPI} from '../../../store/constant';

export default {
    components: {
        AgGridVue,
        vSelect,
        // Cell Renderer
        Datepicker,
        CellRendererActions,
        Pagination,
        flatPickr,
        CellRendererImg,
        DateRangePicker,
        CellRendererDataAI,
        // TitleScreen
    },
    data() {
        return {
            showImg: false,
            imageUrl: "",
            searchQuery: "",
            maxPageNumbers: 7,
            // AgGrid
            gridApi: null,
            gridOptions: {
                rowHeight: 70
            },
            defaultColDef: {},
            columnDefs: [
                {
                    headerName: 'STT',
                    field: 'stt',
                    width: 100,
                    suppressSizeToFit: true,
                },
                {
                    headerName: this.$t('menuHistory.employeeCode'),
                    field: 'employeeCode',
                    minWidth: 100,
                    tooltipField: 'employeeCode'
                },
                {
                    headerName: this.$t('menuHistory.employeeName'),
                    field: 'fullName',
                    minWidth: 160,
                    tooltipField: 'fullName'
                },
                {
                    headerName: this.$t('menuHistory.device'),
                    field: 'deviceTypeStr',
                    minWidth: 100,
                    tooltipField: 'deviceTypeStr'
                },
                {
                    headerName: this.$t('menuHistory.deviceName'),
                    field: 'cameraName',
                    minWidth: 150,
                    tooltipField: 'cameraName'
                },
                {
                    headerName: this.$t('menuHistory.img'),
                    field: 'imageUrl',
                    minWidth: 150,
                    cellRenderer: 'CellRendererActions',
                },
                // {
                //     headerName: this.$t('menuHistory.featureAi'),
                //     width: 200,
                //     cellRenderer: 'CellRendererDataAI',
                // },
                {
                    headerName: this.$t('menuHistory.time'),
                    field: 'checkinTime',
                    minWidth: 150,
                    tooltipField: 'checkinTime'
                }
            ],
            // Cell Renderer Components
            components: {
                CellRendererActions,
                CellRendererDataAI,
            },
            employeeData: [],
            workShiftData: [],
            organizationBranchOptions: [],
            employeeOptions: [
                {value: null, label: this.$t('menuHistory.all')}
            ],
            selectedOrganizationBranchValue: null,
            selectedEmployeeValue: null,
            cameraOptions: [{value: null, label: this.$t('menuHistory.all')}],
            padsData: [{value: null, label: this.$t('menuHistory.all')}],
            deviceOptions: [
                {value: null, label: this.$t('menuHistory.all')},
                {value: 'camera', label: "Camera"},
                {value: 'pad', label: "Pad"},
            ],
            deviceId: null,
            cameraId: null,
            padId: null,
            dateRange: {
                endDate: new Date(),
                startDate: new Date(new Date().setHours(0, 0, 0))
            },
            pageSize: 20,
            pageNumber: 0,
            totalElements: 0,
            currentPage: 1,
            totalPages: 0,
            autoSizeStrategy: {
                type: 'fitGridWidth',
            },
            departmentOptions: [],
            selectedDepartmentValue: null,
        }
    },
    created() {
        this.selectedEmployeeValue = this.$route.query.employeeId ? parseInt(this.$route.query.employeeId) : null;
        this.initScreen()
    },
    watch: {
        '$store.state.windowWidth'(val) {
            if (val > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },
        '$store.state.reduceButton'() {
            setTimeout(() => {
                this.gridApi.sizeColumnsToFit();
            }, 650);
        },
    },
    computed: {
        selectedCamera: {
            get() {
                if (this.cameraOptions.length > 0) {
                    return {
                        label: this.cameraOptions.find(x => x.value == this.cameraId).label,
                        value: this.cameraId
                    }
                }
            },
            set(obj) {
                this.cameraId = obj.value
            }
        },
        selectedPad: {
            get() {
                if (this.padsData.length > 0) {
                    return {
                        label: this.padsData.find(x => x.value == this.padId).label,
                        value: this.padId
                    }
                }
            },
            set(obj) {
                this.padId = obj.value
            }
        },

        selectedDevice: {
            get() {
                if (this.deviceOptions.length > 0) {
                    return {
                        label: this.deviceOptions.find(x => x.value == this.deviceId).label,
                        value: this.deviceId
                    }
                }
            },
            async set(obj) {
                this.deviceId = obj.value
                if (this.deviceId === 'camera') {
                    await this.getCameraByBranch();
                    this.selectedCamera = this.cameraOptions[0];
                }
                if (this.deviceId === 'pad') {
                    await this.getHardwareDevice();
                    this.selectedPad = this.padsData[0];
                }
                if (!this.deviceId) {
                    this.cameraId = null;
                    this.padId = null;
                }
            }
        },
        selectedOrganizationBranch: {
            get() {
                return {
                    label: this.organizationBranchString(this.selectedOrganizationBranchValue),
                    value: this.selectedOrganizationBranchValue
                }
            },
            async set(obj) {
                this.selectedOrganizationBranchValue = obj ? obj.value : null;
                await this.loadDepartment();
                await this.loadEmployee();
                // this.selectedDevice = this.deviceOptions[0]
                this.deviceId = null;
            }
        },
        selectedDepartment: {
            get() {
                let obj = this.departmentOptions.find(el => el.value === this.selectedDepartmentValue);
                if (!obj) return;
                return {
                    label: obj.label,
                    value: obj.value,
                }
            },
            set(obj) {
                this.selectedDepartmentValue = obj ? obj.value : null;
                this.loadEmployee();
            }
        },
        selectedEmployee: {
            get() {
                return {
                    label: this.employeeString(this.selectedEmployeeValue),
                    value: this.selectedEmployeeValue
                }
            },
            set(obj) {
                this.selectedEmployeeValue = obj.value
            }
        }
    },
    methods: {
        isPermissionExport() {
            return isAPI(this, constAPI.in_out_history_add)
        },
        dateRangePicker: function () {
            this.dateRange.startDate = new Date(this.dateRange.startDate.setHours(0, 0, 0));
            this.dateRange.endDate = new Date(this.dateRange.endDate.setHours(23, 59, 59));
        },
        getHardwareDevice() {
            return new Promise((resolve, reject) => {
                this.$vs.loading()
                let data = {
                    organizationBranchId: this.selectedOrganizationBranchValue
                }
                this.padsData = [];
                this.$str.post('/device/find-by-condition', data).then(res => {
                    if (res.data.content && res.data.content.length > 0) {
                        this.padsData = res.data.content.map(item => {
                            return {value: item.id, label: item.deviceName}
                        });
                    }
                    this.padsData.unshift({value: null, label: this.$t('menuHistory.all')})
                    this.$vs.loading.close()
                    resolve()
                }).catch(err => {
                    this.$vs.loading.close();
                    reject()
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                })
            })

        },
        getCameraByBranch() {
            return new Promise((resolve, reject) => {
                let url = this.selectedOrganizationBranchValue ? `/camera/find-by-organization-branch/${this.selectedOrganizationBranchValue}` : `/camera/all`
                this.$vs.loading();
                this.$crm.post(url).then((response) => {
                    this.cameraOptions = response.data.map(item => {
                        return {value: item.id, label: item.cameraName}
                    });
                    this.cameraOptions.unshift({value: null, label: this.$t('menuHistory.all')})
                    this.$vs.loading.close();
                    resolve()
                }).catch((err) => {
                    this.$vs.loading.close();
                    reject()
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })

        },
        mouseOver: function () {
            this.active = !this.active;
        },
        // updateSearchQuery(val) {
        //     this.gridApi.setQuickFilter(val)
        // },
        organizationBranchString(id) {
            let organizationBranch = this.organizationBranchOptions.find(x => x.value === id);
            return (organizationBranch && organizationBranch.label) || this.$t('menuHistory.determine');
        },
        employeeString(id) {
            let employee = this.employeeOptions.find(x => x.value === id);
            return (employee && employee.label) || this.$t('menuHistory.undefined');
        },
        validateForm() {
            return !this.errors.any()
        },
        filter() {
            let searchInfo = {
                deviceType: this.deviceId,
                organizationBranchId: this.selectedOrganizationBranchValue,
                departmentId: this.selectedDepartmentValue,
                employeeId: this.selectedEmployee.value ? [this.selectedEmployee.value] : null,
                cameraId: this.deviceId == this.deviceOptions[1].value ? this.cameraId : this.padId,
                start: this.dateRange.startDate,
                end: this.dateRange.endDate,
                pageSize: this.pageSize,
                pageNumber: this.pageNumber,
                faceType: 'employee',
            }
            let that = this;
            that.$vs.loading();
            that.$crm.post('/time-keeping/all-in-out-org', searchInfo).then((response) => {
                if (response.data.content && response.data.content.length > 0) {
                    that.workShiftData = response.data.content.map(res => {
                        res.stt = this.pageNumber * this.pageSize + response.data.content.indexOf(res) + 1;
                        // if (res.organizationBranchId != that.selectedOrganizationBranchValue) return;
                        // let employee = that.employeeData.find(emp => emp.employeeId === res.employeeId);
                        // if (employee) {
                        //     res.employeeCode = employee.employeeCode;
                        //     // res.fullName = employee.fullName;
                        //     if (res.deviceType.toLowerCase() === 'camera') {
                        //         let camera = this.cameraOptions.find(x => x.value === res.cameraId);
                        //         res.cameraName = camera ? camera.label : '';
                        //         res.deviceType = res.deviceType.toUpperCase();
                        //     } else if (res.deviceType.toLowerCase() === 'pad') {
                        //         let pad = this.padsData.find(x => x.value === res.cameraId);
                        //         res.cameraName = pad ? pad.label : '';
                        //         res.deviceType = res.deviceType.toUpperCase();
                        //     }
                        // }
                        res.employeeCode = res.employee.employeeCode;
                        res.fullName = res.employee.fullName;
                        res.deviceTypeStr = res.deviceType.toUpperCase();
                        return res;
                    });

                    that.workShiftData = that.workShiftData.filter(x => x != undefined);
                    that.workShiftData.forEach(x => {
                        x.checkinTime = x.createdAt ? moment(x.createdAt).format("HH:mm:ss DD/MM/YYYY") : null;
                        if (x.imageUrl && !x.imageUrl.match('http')) {
                            x.imageUrl = authConfig.processorDomain + "storage/" + x.imageUrl
                        }
                    });
                } else {
                    that.workShiftData = [];
                }

                that.totalPages = response.data.totalPages;
                that.totalElements = response.data.totalElements;

                that.$vs.loading.close();
            }).catch((err) => {
                that.$vs.loading.close();
                return that.$vs.notify({
                    title: 'Error',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        exportFile() {
            let searchInfo = {
                organizationBranchId: this.selectedOrganizationBranchValue,
                employeeId: this.selectedEmployee.value ? [this.selectedEmployee.value] : null,
                start: this.dateRange.startDate,
                end: this.dateRange.endDate
            };

            this.$vs.loading();
            this.$crm.post('/time-keeping/create-in-out-org', searchInfo).then((response) => {
                this.$vs.loading.close();
                window.open(authConfig.crmDomain + "file/" + response.data.fileName + "?access_token=" + localStorage.getItem("access_token"), "_blank");
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Error',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        onGridReady() {
            // if (this.$store.state.windowWidth > 1024) {
            //     this.gridApi.sizeColumnsToFit();
            // }
        },
        async initScreen() {
            let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]')
            if (branchList.length == 0) return;
            this.organizationBranchOptions = branchList.filter(el => el.organizationBranchType !== 3).map(item => {
                return {value: item.id, label: item.organizationBranchName}
            })
            this.organizationBranchOptions.unshift({value: null, label: this.$t('menuIntrusion.all')})

            let branchId = this.$route.query.branch_id;
            let index = 0;
            if (branchId) {
                index = this.organizationBranchOptions.findIndex(item => item.value == branchId)
            }
            this.selectedOrganizationBranch = this.organizationBranchOptions[index > -1 ? index : 0];
            // await this.loadEmployee();
            // await this.getCameraByBranch();
            // await this.getHardwareDevice();
            this.filter();
        },
        loadEmployee() {
            // if (!this.selectedOrganizationBranchValue) return;
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                let employeeSearchDTO = {
                    // enable: true,
                    organizationBranchId: this.selectedOrganizationBranchValue,
                    departmentId: this.selectedDepartmentValue,
                }
                this.$crm.post(`/employee/all`, employeeSearchDTO).then((response) => {
                    this.$vs.loading.close();
                    this.employeeData = response.data;
                    this.employeeOptions = response.data.map(item => {
                        return {
                            value: item.employeeId,
                            label: item.employeeCode + "_" + item.fullName
                        }
                    });
                    this.employeeOptions.unshift({value: null, label: this.$t('menuHistory.all')})
                    resolve()
                }).catch((err) => {
                    this.$vs.loading.close();
                    reject()
                    return this.$vs.notify({
                        title: 'Error',
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },

        search() {
            this.pageNumber = 0;
            this.currentPage = 1;
            this.filter();
        },

        changePage: function (currentPage) {
            if (this.pageNumber !== (parseInt(currentPage) - 1)) {
                this.pageNumber = parseInt(currentPage) - 1;
                this.filter();
            }
        },

        setPageSize(e) {
            this.pageSize = e;
            this.search();
        },

        loadDepartment() {
            return new Promise((resolve, reject) => {
                let payload = {
                    organizationBranchId: this.selectedOrganizationBranchValue
                };

                this.$vs.loading();
                this.$crm.post('/department/find-by-condition', payload).then(res => {
                    if (res.data && res.data.length > 0) {
                        this.departmentOptions = res.data.map(el => {
                            return {
                                value: el.id,
                                label: el.departmentName,
                            }
                        })
                    } else {
                        this.departmentOptions = [];
                    }
                    this.departmentOptions.unshift({value: null, label: this.$t('menuOrganization.all')});
                    resolve(res)
                    this.$vs.loading.close();
                }).catch((err) => {
                    reject(err)
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        }
    },
    mounted() {
        this.gridApi = this.gridOptions.api;
    },
}
</script>
